import React, { useState, useEffect } from 'react';
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'
import ManualDash from './ManualDash';


function ManualInvoices() {
    return (
        <div className='contentMain'>
            <LeftBar />
            <div className='theRightOne'>
                <div className='DashTop'>
                    <h1>Manual Invoices</h1>
                    <NavBar />
                </div>
                <ManualDash />
            </div>
        </div>
    )
}

export default ManualInvoices